import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ElevateYourBrandWithSamBrandingAndMarketing from "./sections/ElevateYourBrandWithSamBrandingAndMarketing";
import GoogleBusinessPageManagement from "./sections/GoogleBusinessPageManagement";
import DriveTargetedTrafficWithGoogleAds from "./sections/DriveTargetedTrafficWithGoogleAds";
import EngageAndGrowYourAudienceOnSocialMedia from "./sections/EngageAndGrowYourAudienceOnSocialMedia";
import SeamlessWebDevelopmentManagement from "./sections/SeamlessWebDevelopmentManagement";
import VisuallyCompellingNarratives from "./sections/VisuallyCompellingNarratives";
import PackagingDesignProductDevelopment from "./sections/PackagingDesignProductDevelopment";
import RedefineYourBrandIdentity from "./sections/RedefineYourBrandIdentity";
import MemorableEventPlanning from "./sections/MemorableEventPlanning";
import CaptureTheEssenceOfMoments from "./sections/CaptureTheEssenceOfMoments";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ElevateYourBrandWithSamBrandingAndMarketing />
      <GoogleBusinessPageManagement />
      <DriveTargetedTrafficWithGoogleAds />
      <EngageAndGrowYourAudienceOnSocialMedia />
      <SeamlessWebDevelopmentManagement />
      <VisuallyCompellingNarratives />
      <PackagingDesignProductDevelopment />
      <RedefineYourBrandIdentity />
      <MemorableEventPlanning />
      <CaptureTheEssenceOfMoments />
      <Footer />
    </div>;
}